import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import {
  Home,
  Login,
  Register,
  Statistics,
  Backlogs,
  Tasks,
  Settings,
  Invite,
  Projects,
  Today,
  Pending,
  Project,
  ProjectSettings,
  TimeTracking,
} from "@views";

const TIMER_ENABLED = import.meta.env.VITE_ENABLE_TIMER === "true";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/invite/:token" element={<Invite />} />
        <Route element={<AppShell />}>
          <Route path="/dashboard" element={<Navigate to="/tasks" replace />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/calendar" element={<Navigate to="/tasks?view=calendar" replace />} />
          <Route path="/kanban" element={<Navigate to="/tasks?view=kanban" replace />} />
          <Route path="/today" element={<Today />} />
          <Route path="/pending" element={<Pending />} />
          <Route path="/backlogs" element={<Backlogs />} />
          <Route path="/statistics" element={<Statistics />} />
          {TIMER_ENABLED && <Route path="/time-tracking" element={<TimeTracking />} />}
          <Route path="/settings" element={<Settings />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:id" element={<Project />} />
          <Route path="/project/:id/settings" element={<ProjectSettings />} />
        </Route>
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;